<template>
  <div id="question-view" class="view desktop" :class="{ loading: loading }">
    <div class="next desktop" @click="prevQuestion" v-if="atQuestion > 0">
      <i class="fa fa-angle-left" aria-hidden="true"></i>
      Tillbaka
     </div>
    <div class="top gradient-ani" :style="{ backgroundImage: gradientBackground }">
      <div class="darkness" :style="{ opacity: darknessOpacity }"></div>
      <div class="question-container">
        <div
          class="emoji"
          v-html="currentQuestion.emoji_html"
        >
        </div>
        <h1>Påstående {{ atQuestion + 1 }}</h1>
        <p>{{currentQuestion.text}}</p>
        <div class="anti-transition"><the-karta :atQuestion="atQuestion" /></div>
        <div class="answer-container anti-transition">
          <div class="reponses">
            <div class="response nej outline" :class="{ active: answered === false  }" @click="nextQuestion(false)"></div>
            <div class="response ja" :class="{ active: answered === true  }" @click="nextQuestion(true)"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TWEEN from 'tween.js'
import TheKarta from '@/components/TheKarta'
export default {
  name: 'QuestionViewDesktop',
  data () {
    return {
      loading: true,
      answered: null,
      currentRotation: 0,
      gradients: [
        ['#fd9b8e', '#ff0846']
      ]
    }
  },
  props: ['atQuestion', 'currentQuestion'],
  computed: {
    darknessOpacity () {
      if (this.atQuestion < 3) return 0
      return (this.atQuestion / 13)
    },
    gradientBackground () {
      return 'linear-gradient(' +
        this.currentRotation + 'deg, ' +
        this.gradients[0][0] + ' 0%, ' +
        this.gradients[0][1] + ' 100%)'
    }
  },
  watch: {
    currentRotation () {
      if (this.currentRotation === 360) {
        this.currentRotation = 0
        this.tween(0, 360)
      }
    }
  },
  methods: {
    nextQuestion (answer) {
      this.loading = true
      this.answered = answer
      window.setTimeout(() => {
        this.$emit('answer', answer)
        this.loading = false
        this.answered = null
      }, 500)
    },
    prevQuestion () {
      this.loading = true
      window.setTimeout(() => {
        this.$emit('back')
        this.loading = false
        this.answered = null
      }, 500)
    },
    tween (start, end) {
      let frameHandler = null
      const tweenDuration = 10000
      const animate = function (currentTime) {
        TWEEN.update(currentTime)
        frameHandler = window.requestAnimationFrame(animate)
      }
      new TWEEN.Tween({ tweeningValue: start })
        .to({ tweeningValue: end }, tweenDuration)
        .onUpdate((tweenObj) => {
          this.currentRotation = tweenObj * 360
        })
        .onComplete(() => {
          cancelAnimationFrame(frameHandler)
        })
        .start()
      frameHandler = window.requestAnimationFrame(animate)
    }
  },
  mounted () {
    //  console.log(this.gradientBackground)
    this.tween(0, 360)
    window.setTimeout(() => {
      this.loading = false
    }, 200)
  },
  components: { TheKarta }
}
</script>

<style scoped>
.next {
  color: #fff;
  position: absolute;
  top: 4vh;
  left: 4.6vh;
  z-index: 999;
  font-size: 0.95em;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.2s ease-in;
}
.next:hover {
  left: 4.2vh;
}
*:focus {
  outline: 0;
}
.karta {
  width: 470px;
  margin: 5vh 0;
}
* {
  box-sizing: border-box;
}
h1, p {
  margin: 0;
  max-width: calc(100% - 60px);
}
h1 {
  text-transform: uppercase;
  font-size: 1.3rem;
  letter-spacing: 1px;
  margin-bottom: 5px;
}
p {
  font-size: 1.2rem;
  max-width: 420px;
}
.darkness {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0;
  transition: all 1s ease-in;
}
.emoji {
  margin: auto;
  height: 20vh;
  text-align: center;
  font-size: 10vh;
  z-index: 99;
  text-shadow: 2px 2px 9px rgba(0, 0, 0, 0.1);
}
.view {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.top {
  background-color: pink;
  flex-grow: 1;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
}
.answer-container, .question-container {
  width: 100%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 1;
  transition: all 0.5s ease;
}
.question-container {
  position: relative;
  left: 0;
  z-index: 100;
}
.loading .answer-container, .loading .question-container {
  opacity: 0;
}
.loading .question-container {
  transform: translateY(-20vh);
}
.loading .answer-container {
}
.reponses {
  display: flex;
  flex-direction: row;
  width: 80%;
  padding-top: 4vh;
}
.response {
  flex-grow: 1;
  font-size: 5vh;
  font-weight: bold;
  text-transform: uppercase;
  color: #fff;
  letter-spacing: 2px;
  padding: 4px;
  cursor: pointer;
  transition: all 0.5s ease;
  box-sizing: border-box;
  height: 4vh;
  width: 3vw;
  background-repeat: no-repeat;
  background-size: contain;
  padding: 4px;
  background-position: center center;
}
.response:hover {
  transform: scale(1.1);
  transition: all 0.2s ease;
}
.nej {
  background-image: url('../assets/img/nej_w.svg');
}
.ja {
  transform: scale(0.95);
  background-image: url('../assets/img/ja_w.svg');
}
.ja.active {
  transition: all 0.5s ease;
  transform: scale(1.8);
}
.nej.active {
  transition: all 0.5s ease;
  transform: scale(1.8);
}
.outline {
  color: transparent;
  -webkit-text-stroke: 1px #fff;
}
.gradient-ani {
  transition: all 3s ease;
}
.loading .anti-transition {
  transition: all 0.8s ease;
  transform: translateY(13vh);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionViewDesktop.vue